import React, { useEffect, useState } from 'react'
import { ColorRing } from 'react-loader-spinner';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { Button } from 'reactstrap';
import { BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Icon } from '../../../../components/Component';
import ReactDataTable from './ReactDataTable/ReactDataTable';
import ToastExample from '../../../../helpers/toast';
import Content from '../../../../layout/content/Content';
import Head from '../../../../layout/head/Head';
import { toggleAddonCategory } from '../../../../redux/admin/addon/action';
import { getStoreAddonCategories } from '../../../../redux/admin/store/action';
import { Table } from 'antd';

function StoreAddonCategories() {
    const { store_id } = useParams();

    const getSelectors = (state) => ({
        categories: state.store.store_addon_categories,
    });
    const [loading, setLoading] = useState(false);
    const { categories } = useSelector(getSelectors);
    const dispatch = useDispatch();
    useEffect(() => {
        setLoading(true);
        dispatch(getStoreAddonCategories(store_id)).then((response) => {
            setLoading(false);
        })
    }, [])
    const [showToast, setShowToast] = useState(false);   //toast state
    const handleCategoryStatus = (e, id) => {
        dispatch(toggleAddonCategory(id));
        setTimeout(() => {
            dispatch(getStoreAddonCategories(store_id));
            setShowToast(true);
        }, 500);

        setTimeout(() => {
            setShowToast(false);
        }, 3000);
    };

    const [storeAddonCategoriesTableDatas, setStoreAddonCategoriesTableDatas] = useState([]); // for deleting store


    const dataTableColumns = [
        {
            name: "Name",
            selector: (row) => row.name,
            sortable: true,
        },
        {
            name: "Type",
            selector: (row) => row.type,
            sortable: true,
        },
        {
            name: "Addon",
            selector: (row) => row.addons?.length,
            sortable: true,
        },
        {
            name: "Status",
            selector: (row) => row.startDate,
            cell: (row) => (
                <Button color={row?.is_active ? "success" : "danger"} onClick={(e) => {
                    handleCategoryStatus(e, row?.id)
                }}>
                    {row?.is_active ? <Icon name="stop-circle-fill" /> : <Icon name="play-circle-fill" />}
                </Button>
            )
        },
    ];

    return (
        <React.Fragment>
            <Head title="Store Addon Categories"></Head>
            {loading ?
                <Content>
                    <div className='d-flex align-items-center justify-content-center' style={{ minHeight: '75vh' }}>
                        <ColorRing
                            visible={true}
                            height="80"
                            width="80"
                            ariaLabel="blocks-loading"
                            wrapperStyle={{}}
                            wrapperClass="blocks-wrapper"
                            colors={['#fcc314', '#fcc314', '#fcc314', '#fcc314', '#fcc314']}
                        />
                    </div>
                </Content>
                :
                <Content>
                    <BlockHead size="sm">
                        <BlockBetween>
                            <BlockHeadContent>
                                <BlockTitle tag="h3" page>
                                    Store Addon Categories
                                </BlockTitle>
                                <BlockDes className="text-soft">
                                    <p>You have total {categories?.length} Addon Categories.</p>
                                </BlockDes>
                            </BlockHeadContent>
                            <BlockHeadContent>
                                <div className="toggle-wrap nk-block-tools-toggle">
                                    <ToastExample
                                        show={showToast}
                                    />
                                </div>
                            </BlockHeadContent>
                        </BlockBetween>
                    </BlockHead>
                    {/* datatable */}
                    <ReactDataTable data={categories} columns={dataTableColumns} expandableRows pagination />
                </Content>
            }
        </React.Fragment>
    )
}

export default StoreAddonCategories
